const TABLE_TYPES = ['Свободные', 'Прикрепленные', 'Списанные'];

export default TABLE_TYPES;
